<template>
  <v-container fluid class="bg-image">
    <v-row justify="start">
      <v-btn @click="$router.push('/welcome')" color="primary" text>
        <v-icon>mdi-chevron-left</v-icon>
        {{ $t("go_back") }}
      </v-btn>
      <v-btn text color="primary" @click="changeLang('en')">EN</v-btn>
      <p class="my-0 mt-1 primary--text">|</p>
      <v-btn text color="primary" @click="changeLang('fr')">FR</v-btn>
    </v-row>
    <div v-if="registrationSuccessfull" class="vh100">
      <v-layout align-center justify-center>
        <v-row justify="center" class="mt-5">
          <v-img
            :src="imageLogoUrlBlue"
            max-height="200px"
            contain
            aspect-ratio="1.7"
          ></v-img>
        </v-row>
      </v-layout>
      <v-layout align-center justify-center>
        <v-card color="background" elevation="0" flat>
          <v-card-title primary-title class="py-0 pb-7 pt-2">
            <v-row justify="center">
              <span class="text-h5 font-weight-light primary--text"
                >SUCCESS!</span
              >
            </v-row>
          </v-card-title>
          <v-card-text class="py-0 text-center">
            <p class="primary--text subtitle-1 font-weight-medium">
              {{ $t("registration_successful") }}
              <br />
              {{ $t("email_confirmation") }}
            </p>
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-row justify="center">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-btn
                  @click="
                    $router.push('/login');
                    registrationSuccessfull = false;
                  "
                  class="py-6 px-11"
                  large
                  color="primary"
                  >CONFIRM</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-layout>
    </div>
    <v-layout align-center justify-center v-else>
      <v-flex xs12 sm8 md8 class="text-center">
        <v-row justify="center">
          <v-img
            :src="imageLogoUrlBlue"
            max-height="200px"
            contain
            aspect-ratio="1.7"
          ></v-img>
        </v-row>
        <v-card class="transparent-card" flat>
          <v-card-title primary-title class="py-0 pb-7 pt-1">
            <v-row justify="center">
              <span class="text-h5 font-weight-regular primary--text">{{
                $t("sign_up")
              }}</span>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="font-weight-regular primary--text">{{
            $t("account_holder_info")
          }}</v-card-subtitle>
          <v-card-text>
            <v-form ref="user-form">
              <v-row>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('first_name_required'))]"
                    v-model="user.first_name"
                    flat
                    solo
                    :placeholder="$t('first_name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('last_name_required'))]"
                    v-model="user.last_name"
                    flat
                    solo
                    :placeholder="$t('last_name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('email_required')), email()]"
                    v-model="user.email"
                    flat
                    solo
                    :placeholder="$t('email')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    v-mask="['(###)###-#####', '+#(###)###-####']"
                    :rules="[required($t('phone_required'))]"
                    v-model="user.phone"
                    flat
                    solo
                    :placeholder="$t('phone_number')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" class="py-0">
                  <gmap-autocomplete
                    @place_changed="locationSelected"
                    autocomplete="no"
                  >
                    <template v-slot:input="slotProps" autocomplete="no">
                      <v-text-field
                        :rules="[required($t('address_line_required'))]"
                        v-model="user.address.address_line_1"
                        ref="input"
                        :placeholder="$t('address_line_1')"
                        v-on:listeners="slotProps.listeners"
                        v-on:attrs="slotProps.attrs"
                        @focus.prevent="stopChromeAutocompletePopup($event)"
                        id="addressInput"
                        autocomplete="no"
                        flat
                        solo
                      ></v-text-field>
                    </template>
                  </gmap-autocomplete>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    v-model="user.address.address_line_2"
                    flat
                    solo
                    :placeholder="$t('address_line_2')"
                    autocomplete="no"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('city_is_required'))]"
                    v-model="user.address.city"
                    flat
                    solo
                    :placeholder="$t('city')"
                    autocomplete="no"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('province_required'))]"
                    v-model="user.address.province"
                    flat
                    solo
                    :placeholder="$t('province')"
                    autocomplete="no"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('postal_code_is_required'))]"
                    v-model="user.address.postal_code"
                    flat
                    solo
                    :placeholder="$t('postal_code')"
                    autocomplete="no"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('country_is_required'))]"
                    v-model="user.address.country"
                    flat
                    solo
                    :placeholder="$t('country')"
                    autocomplete="no"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    :return-value.sync="user.dob"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        solo
                        flat
                        v-model="user.dob"
                        :rules="[required($t('date_of_birth_required'))]"
                        :placeholder="$t('date_of_birth')"
                        append-icon="mdi-event"
                        readonly
                        v-on="on"
                        @click="triggerYearPicker"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @click:date="$refs.menu.save(user.dob)"
                      ref="picker"
                      min="1900-01-01"
                      :max="new Date().toISOString().substr(0, 10)"
                      v-model="user.dob"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <!-- <v-btn text color="primary" @click="$refs.menu.save(user.dob)">OK</v-btn> -->
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
            <v-form ref="password-form">
              <v-row>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[
                      required($t('password_required')),
                      strongPassword($t('password_requirements')),
                    ]"
                    v-model="user.password"
                    flat
                    solo
                    :placeholder="$t('password')"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    :success="
                      user.password !== '' &&
                      user.password === user.confirm_password &&
                      strongPasswordRegex.test(user.password)
                    "
                    :outlined="
                      user.password !== '' &&
                      user.password === user.confirm_password &&
                      strongPasswordRegex.test(user.password)
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[
                      required($t('confirm_password_required')),
                      confirmPassword(
                        user.password,
                        user.confirm_password,
                        $t('password_match')
                      ),
                    ]"
                    v-model="user.confirm_password"
                    flat
                    solo
                    :placeholder="$t('confirm_password')"
                    :append-icon="
                      showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    :type="showConfirmPassword ? 'text' : 'password'"
                    @click:append="showConfirmPassword = !showConfirmPassword"
                    :success="
                      user.password !== '' &&
                      user.password === user.confirm_password &&
                      strongPasswordRegex.test(user.confirm_password)
                    "
                    :outlined="
                      user.password !== '' &&
                      user.password === user.confirm_password &&
                      strongPasswordRegex.test(user.confirm_password)
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-title primary-title class="py-0 py-7">
            <v-row justify="center">
              <span class="text-h5 font-weight-regular primary--text">{{
                $t("payment_information")
              }}</span>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="font-weight-regular primary--text"
            >**{{ $t("card_charged") }}**</v-card-subtitle
          >
          <v-card-text>
            <v-form ref="payment-form">
              <v-row>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('first_name_required'))]"
                    v-model="payment.first_name"
                    flat
                    solo
                    :placeholder="$t('first_name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('last_name_required'))]"
                    v-model="payment.last_name"
                    flat
                    solo
                    :placeholder="$t('last_name')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('email_required')), email()]"
                    v-model="payment.email"
                    flat
                    solo
                    :placeholder="$t('email')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <v-text-field
                    :rules="[required($t('phone_required'))]"
                    v-mask="'(###)###-####'"
                    v-model="payment.phone_number"
                    flat
                    solo
                    :placeholder="$t('phone_number')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" class="py-0">
                  <card
                    v-if="mountStripe"
                    class="stripe-card StripeElement"
                    :stripe="getStripeKey"
                    :options="stripeOptions"
                    @change="complete = $event.complete"
                  />
                  <v-row class="px-4 pt-2">
                    <img
                      class="credit-cards"
                      src="@/assets/images/cards/1.png"
                    />
                    <img
                      class="credit-cards ml-2"
                      src="@/assets/images/cards/2.png"
                    />
                    <img
                      class="credit-cards ml-2"
                      src="@/assets/images/cards/22.png"
                    />
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
            <v-row justify="start" class="pt-3 mt-3">
              <v-col cols="12" md="8" offset-lg="3" offset-md="2">
                <v-checkbox
                  hide-details
                  :value="user.meta.agree_to_terms"
                  class="ma-0 pa-0"
                  readonly
                  @click.stop="handleTermsAndConditionsClick"
                >
                  <template v-slot:label>
                    <div class="primary--text">
                      {{ $t("agree_travelzoo_1") }}
                      <a @click.capture="termsAndConditions.dialog = true">{{
                        $t("agree_travelzoo_2")
                      }}</a>
                      {{ $t("agree_travelzoo_3") }}
                      <a
                        @click.capture="
                          $router.push('privacy-policy-travelzoo')
                        "
                        >{{ $t("agree_travelzoo_4") }}</a
                      >
                    </div>
                  </template>
                </v-checkbox>
                <v-checkbox
                  hide-details
                  :value="user.meta.agree_to_privacy_policy"
                  readonly
                  @click.stop="handlePrivacyPolicyClick"
                  class="ma-0 pa-0 py-2"
                >
                  <template v-slot:label class="primary--text">
                    <div class="primary--text">
                      {{ $t("share_information_1") }}
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            @click.capture="privacyPolicy.dialog = true"
                            v-on="on"
                            >{{ $t("share_information_2") }}</a
                          >
                        </template>
                        View Policy
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
                <v-checkbox
                  hide-details
                  v-model="user.meta.marketing_opt_in"
                  class="ma-0 pa-0 primary--text mt-2"
                >
                  <template v-slot:label>
                    <div class="primary--text">
                      {{ $t("agree_labatt_1") }}
                      <a
                        @click.prevent="
                          ($event) =>
                            goToLink('https://www.labattbrands.com/', $event)
                        "
                        >{{ $t("agree_labatt_2") }}</a
                      >
                      . {{ $t("agree_labatt_3") }}
                      <a
                        @click.prevent="
                          ($event) =>
                            goToLink(
                              'https://contactus.anheuser-busch.com/ContactUs/coronaextra/contact_us.asp',
                              $event
                            )
                        "
                        target="_blank"
                        >{{ $t("agree_labatt_4") }}</a
                      >
                      {{ $t("agree_labatt_5") }}
                      <a @click="$router.push('/privacy-policy')">{{
                        $t("agree_labatt_6")
                      }}</a>
                      {{ $t("agree_labatt_7") }}
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-row justify="center">
              <v-col cols="12" class="ma-0 pa-0 text-center">
                <v-tooltip :disabled="user.meta.agree_to_terms" top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn
                        :disabled="
                          !user.meta.agree_to_terms ||
                          !user.meta.agree_to_privacy_policy
                        "
                        @click="handleSubmit"
                        class="px-8"
                        large
                        color="primary"
                        >{{ $t("sign_up") }}</v-btn
                      >
                    </div>
                  </template>
                  <span>{{ $t("accept_terms_and_conditions") }}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="8" class="text-center primary--text body-2">
                <p class="primary--text">
                  {{ $t("have_account") }}
                  <a
                    @click.stop.prevent="$router.push('/login')"
                    class="primary--text"
                    >{{ $t("login") }}</a
                  >
                </p>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-if="privacyPolicy.dialog"
      v-model="privacyPolicy.dialog"
      scrollable
      fullscreen
      transition="dialog-transition"
    >
      <v-card>
        <privacy-policy
          @accepted="
            user.meta.agree_to_privacy_policy = true;
            privacyPolicy.dialog = false;
          "
          @close="privacyPolicy.dialog = false"
        />
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="termsAndConditions.dialog"
      v-model="termsAndConditions.dialog"
      scrollable
      fullscreen
      transition="dialog-transition"
    >
      <v-card>
        <terms-and-conditions
          @accepted="
            user.meta.agree_to_terms = true;
            termsAndConditions.dialog = false;
          "
          @close="termsAndConditions.dialog = false"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// user: {
//   first_name: 'Yash',
//   last_name: 'test',
//   email: 'yash+test@unoapp.com',
//   phone: '1231231234',
//   dob: '1990-01-10',
//   meta: {
//     province: 'ON',
//     agree_to_terms: false,
//     agree_to_privacy_policy: false,
//     marketing_opt_in: false
//   },
//   password: 'Unoapp1234!',
//   confirm_password: 'Unoapp1234!'
// },
// payment: {
//   user_id: '2911d5b7-779b-4995-9a0c-8f5d89b3edae',
//   payment_token: '',
//   first_name: 'Yash',
//   last_name: 'test',
//   email: 'yash+test@unoapp.com',
//   phone_number: '1231231234'
// }
import { diffInYears } from '@/utils/datetime'
import { Card, createToken } from 'vue-stripe-elements-plus'
import { CONSUMERS_API } from '@/clients/consumers.api'
import { PAYMENTS_API } from '@/clients/payments.api'
import { Validations, strongPasswordRegex } from '@/utils/validations'
import { importer } from '@/utils/extras'
import { mask } from 'vue-the-mask'
export default {
  created () {
    importer.url('https://js.stripe.com/v3/').then(s => {
      this.mountStripe = true
    })
    // import('https://js.stripe.com/v3/').then(m => {
    //   this.mountStripe = true
    // })
    // this.user = {
    //   first_name: 'Yash',
    //   last_name: 'Test',
    //   email: 'yash+randomtest@unoapp.com',
    //   phone: '1231231234',
    //   dob: '1956-01-01',
    //   meta: {
    //     province: 'ON',
    //     agree_to_terms: true,
    //     agree_to_privacy_policy: true,
    //     marketing_opt_in: true
    //   },
    //   address: {
    //     address_line_1: '670 Caledonia Road',
    //     address_line_2: '',
    //     city: 'Toronto',
    //     postal_code: 'M9V5KC',
    //     country: 'Canada',
    //     latitude: '21',
    //     longitude: '22',
    //     province: 'ON'
    //   },
    //   password: 'Unoapp1234!',
    //   confirm_password: 'Unoapp1234!'
    // }
  },
  directives: { mask },
  data () {
    return {
      registrationSuccessfull: false,
      showPassword: false,
      showConfirmPassword: false,
      provinces: [
        {
          name: 'Alberta',
          abbreviation: 'AB',
          age: 18
        },
        {
          name: 'British Columbia',
          abbreviation: 'BC',
          age: 19
        },
        {
          name: 'Manitoba',
          abbreviation: 'MB',
          age: 18
        },
        {
          name: 'New Brunswick',
          abbreviation: 'NB',
          age: 19
        },
        {
          name: 'Newfoundland and Labrador',
          abbreviation: 'NL',
          age: 19
        },
        {
          name: 'Northwest Territories',
          abbreviation: 'NT',
          age: 19
        },
        {
          name: 'Nova Scotia',
          abbreviation: 'NS',
          age: 19
        },
        {
          name: 'Nunavut',
          abbreviation: 'NU',
          age: 19
        },
        {
          name: 'Ontario',
          abbreviation: 'ON',
          age: 19
        },
        {
          name: 'Prince Edward Island',
          abbreviation: 'PE',
          age: 19
        },
        {
          name: 'Quebec',
          abbreviation: 'QC',
          age: 18

        },
        {
          name: 'Saskatchewan',
          abbreviation: 'SK',
          age: 19
        },
        {
          name: 'Yukon Territory',
          abbreviation: 'YT',
          age: 19
        }
      ],
      termsAndConditionsAccepted: false,
      termsAndConditions: {
        dialog: false
      },
      privacyPolicy: {
        dialog: false
      },
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        dob: '',
        meta: {
          province: '',
          agree_to_terms: false,
          agree_to_privacy_policy: false,
          marketing_opt_in: false
        },
        address: {
          address_line_1: '',
          address_line_2: '',
          city: '',
          postal_code: '',
          country: '',
          latitude: '',
          longitude: '',
          province: '',
          verified: false
        },
        password: '',
        confirm_password: ''
      },
      payment: {
        user_id: '',
        payment_token: '',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: ''
      },
      mountStripe: false,
      strongPasswordRegex
    }
  },
  components: {
    Card,
    TermsAndConditions: () => import('./TermsAndConditionsConfirmation'),
    PrivacyPolicy: () => import('./PrivacyPolicyConfirmation')
  },
  methods: {
    stopChromeAutocompletePopup (event) {
      event.target.autocomplete = 'no'
    },
    ...Validations,
    amOldEnough () {
      return v => this.amIallowed(v) || 'You are not of the legal drinking age to enter the website.'
    },
    amIallowed (date) {
      console.log(this.user.meta.province, date)
      if (date === undefined || this.user.address.province === '') {
        return false
      }
      const userAge = diffInYears(date, new Date())
      console.log(date)
      const province = this.provinces.find(i => i.abbreviation === this.user.address.province)
      console.log('Im here', province)
      return userAge > province.age
    },
    async createStripeToken () {
      let response
      try {
        response = await createToken()
      } catch (error) {
        console.log(error)
        throw error
      }
      if (response.error) {
        console.log()
        if (response.error.message.indexOf('Your postal code is incomplete.') > -1) {
          this.$snackbar({ text: 'Update postal code located in the Payment Information section', color: 'error' })
        } else {
          this.$snackbar({ text: response.error.message, color: 'error' })
        }
        throw response.error
      }
      this.payment.payment_token = response.token.id
    },
    triggerYearPicker () {
      setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    async registerUser () {
      let response
      const data = JSON.parse(JSON.stringify(this.user))
      if (data.address.latitude === '' || data.address.longitude === '') {
        delete data.address.latitude
        delete data.address.longitude
        data.address.verified = false
      } else if (data.address.address_line_1 && data.address.postal_code.length >= 6 && data.address.postal_code.length <= 7 && data.address.country && data.address.city && data.address.province) {
        data.address.verified = true
      }

      try {
        response = await CONSUMERS_API.Auth.register(data)
      } catch (e) {
        this.$snackbar({ text: Array.isArray(e.error.payload) ? e.error.payload.join(' | ') : e.error.msg, color: 'error', timeout: 6500 })
        throw e
      }
      this.payment.user_id = response.payload.user_id
      return response.payload
    },
    async addPaymentMethod (user) {
      let response
      const data = JSON.parse(JSON.stringify(this.payment))
      data.user_id = user.id
      try {
        response = await PAYMENTS_API.PaymentMethods.AddPaymentMethodToCustomer(data)
      } catch (e) {
        this.$snackbar({ text: Array.isArray(e.error.payload) ? e.error.payload.join(' | ') : e.error.payload, color: 'error', timeout: 6500 })
        throw e
      }
      // REDIRECT AT THIS STEPP
    },
    async handleSubmit () {
      if (!this.$refs['user-form'].validate() || !this.$refs['password-form'].validate() || !this.$refs['payment-form'].validate()) {
        await this.$nextTick()
        const el = document.querySelector('.v-messages__message:first-of-type')
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }
      this.$spinner()
      try {
        await this.createStripeToken()
      } catch (error) {
        console.log(error)
        this.$spinner()
        return error
      }
      // register user
      let user
      try {
        user = await this.registerUser()
      } catch (error) {
        console.log(error)
        this.$spinner()
        return error
      }
      // add payment method
      try {
        await this.addPaymentMethod(user)
      } catch (error) {
        console.log(error)
        this.$spinner()
        return error
      }
      this.registrationSuccessfull = true
      this.user.meta.agree_to_terms = false
      this.$spinner()
    },
    handleTermsAndConditionsClick () {
      if (this.user.meta.agree_to_terms) {
        this.user.meta.agree_to_terms = false
      } else {
        this.termsAndConditions.dialog = true
      }
    },
    handlePrivacyPolicyClick () {
      if (this.user.meta.agree_to_privacy_policy) {
        this.user.meta.agree_to_privacy_policy = false
      } else {
        this.privacyPolicy.dialog = true
      }
    },
    locationSelected (addressData) {
      this.googleAddress = addressData
      if (addressData && addressData.address_components) {
        addressData.address_components.forEach((item) => {
          if (item.types.includes('street_number')) {
            this.user.address.address_line_1 = item.short_name
          }
          if (item.types.includes('route')) {
            this.user.address.address_line_1 =
              this.user.address.address_line_1 + ' ' + item.short_name
          }
          if (item.types.includes('sublocality')) {
            this.user.address.city = item.short_name
          }
          if (item.types.includes('locality')) {
            this.user.address.city = item.short_name
          }
          if (
            item.types.includes('administrative_area_level_1' || 'political')
          ) {
            this.user.address.province = item.short_name
          }
          if (item.types.includes('country')) {
            this.user.address.country = item.long_name
          }
          // if (item.types.includes('country')) this.locationAddress.country_code = item.short_name
          if (item.types.includes('postal_code')) {
            this.user.address.postal_code = item.short_name
          }
        })
        this.user.address.latitude = Number(
          addressData.geometry.location.lat().toFixed(6)
        )
        this.user.address.longitude = Number(
          addressData.geometry.location.lng().toFixed(6)
        )
        // this.locationAddress.formatted_address = addressData.formatted_address
        // if (addressData.place_id) { this.locationAddress.google_place_id = addressData.place_id } else { this.locationAddress.google_place_id = null }
      }
    }
  },
  computed: {
    stripeOptions () {
      if (this.va_lang === 'en') {
        return {

          // etc
          elements: {
            locale: 'en'
          }
        }
      } else {
        return {
          // etc
          elements: {
            locale: 'en'
          }
        }
      }
    },
    getStripeKey () {
      return process.env.VUE_APP_STRIPE_KEY
    },
    passwordConfirmPasswordWatcher () {
      return { password: this.user.password, confirmPassword: this.user.confirm_password }
    }
  },
  watch: {
    async 'passwordConfirmPasswordWatcher' (x) {
      if (x.password !== '' && x.confirmPassword !== '' && x.password === x.confirmPassword) {
        await this.$nextTick()
        this.$refs['password-form'].validate()
      }
    },
    va_lang: {
      handler: async function (x) {
        this.mountStripe = false
        await this.$nextTick()
        this.mountStripe = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bg-image {
  background: rgba($color: #f0f0f0, $alpha: 1);
}
.vh100 {
  min-height: 90vh;
}

.credit-cards {
  max-height: 30px;
  width: auto;
}

.transparent-card {
  background: rgba(255, 255, 255, 0);
}
a {
  text-decoration: underline;
}
.stripe-card {
  width: 100%;
}
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 50px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
